import { jsx as r } from "react/jsx-runtime";
import { isButton as u, isButtonLink as f } from "../../../../../../../../utils/isButton.js";
import { B as l } from "../../../../../../../../ActionButton-B77eJAd5.js";
import m from "../../../../../../../controls/ButtonLink/ButtonLink.js";
function p(i) {
  const { cta: n, ...t } = i, o = n === "primary" ? "filled" : "outlined";
  return u(t) ? /* @__PURE__ */ r(l, { ...t, fill: o, width: "100%" }) : f(t) ? /* @__PURE__ */ r(m, { ...t, fill: o, width: "100%" }) : null;
}
export {
  p as default
};
